function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#007a5e",
  d: "M0 0h213.3v480H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ce1126",
  d: "M213.3 0h213.4v480H213.3z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcd116",
  d: "M426.7 0H640v480H426.7z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "#fcd116",
  transform: "translate(320 240) scale(7.1111)"
}, /*#__PURE__*/React.createElement("g", {
  id: "cm_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  id: "cm_svg__a",
  d: "M0-8L-2.5-.4 1.3.9z"
}), /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  transform: "scale(-1 1)",
  xlinkHref: "#cm_svg__a"
})), /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  transform: "rotate(72)",
  xlinkHref: "#cm_svg__b"
}), /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  transform: "rotate(144)",
  xlinkHref: "#cm_svg__b"
}), /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  transform: "rotate(-144)",
  xlinkHref: "#cm_svg__b"
}), /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  transform: "rotate(-72)",
  xlinkHref: "#cm_svg__b"
}));

var SvgCm = function SvgCm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 480"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgCm;